$(document).ready(function() {
    function setupModalQuantitySelector(modalId, product) {
    var $modQtyWrap = $('#' + modalId).find('.mod-qty-wrap');
    $modQtyWrap.empty(); // Clear previous content if any

    var existingQuantity = $(`div[data-variant-id='${product.id}'] .quantity-selector .bb-input`).val() || 0;

    var quantityInputHtml = `
        <div class="modal-quantity-selector">
            <button class="modal-decrease-quantity">-</button>
            <input type="number" class="modal-quantity-input" name="modal-quantity-${product.id}" value="${existingQuantity}" min="0" data-product-id="${product.id}">
            <button class="modal-increase-quantity">+</button>
        </div>
    `;

    $modQtyWrap.html(quantityInputHtml);

    // Remove any previously attached event handlers to prevent duplication
    $modQtyWrap.off('click', '.modal-decrease-quantity, .modal-increase-quantity');

    $modQtyWrap.on('click', '.modal-decrease-quantity, .modal-increase-quantity', function() {
        var $input = $(this).siblings('.modal-quantity-input');
        var newValue = parseInt($input.val());
        newValue += $(this).hasClass('modal-increase-quantity') ? 1 : -1;
        newValue = newValue >= 0 ? newValue : 0;
        $input.val(newValue);
        synchronizeQuantities(product.id, newValue);
        updateFooterBar();
    });
}

    function synchronizeQuantities(productId, newQuantity) {
    $(`div[data-variant-id='${productId}'] .quantity-selector .bb-input`).val(newQuantity);
    $(`.modal-quantity-input[data-product-id='${productId}']`).val(newQuantity);

    // Trigger a custom event to notify the bb_summary.js script
    $(document).trigger('updateQuantities');
    updateFooterBar();
}

    function updateFooterBar() {
        var totalQuantity = 0;
        var totalValue = 0;

        $('.bb-input').each(function() {
            var quantity = parseInt($(this).val());
            var price = parseFloat($(this).closest('.product-item').data('price'));
            totalQuantity += quantity;
            totalValue += quantity * price;
        });

        $('#total-quantity').text(totalQuantity);
        $('#total-value').text(currencySymbol + totalValue.toFixed(2));
    }

    $('.button').click(function() {
        var modalId = $(this).data('target');
        var productId = $(this).closest('.product-item').data('variant-id');
        setupModalQuantitySelector(modalId, {id: productId});
        $('#' + modalId).fadeIn();
    });

    $('.mod-close').click(function() {
        var modalId = $(this).data('close');
        $('#' + modalId).fadeOut();
    });

    $(window).click(function(event) {
        if ($(event.target).hasClass('modal')) {
            $(event.target).fadeOut();
        }
    });

    $('.quantity-selector .bb-input').on('input', function() {
        var productId = $(this).closest('.product-item').data('variant-id');
        var newQuantity = $(this).val();
        synchronizeQuantities(productId, newQuantity);
    });

    updateFooterBar(); // Initial update on page load
});
